import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Layout } from 'features/common/components/Layout';
import { ClientPaymentsList } from '../../features/salesOrder/components/ClientPaymentsList';
import { ReceiptsByChannelPanel } from '../../features/salesOrder/components/ReceiptsByChannelPanel';
import { RootState } from 'store';
import { isOperatorOrHigher } from 'features/auth/helpers';
import routes from 'constants/routes';

export const ClientPaymentsListPage = (): JSX.Element => {
	const auth = useSelector((state: RootState) => state.auth);
	const [tab, setTab] = useState(0);

	if (!isOperatorOrHigher(auth.user)) {
		return <Redirect to={routes.home} />;
	}

	return (
		<Layout>
			<Grid container spacing={2} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
						<Tabs value={tab} onChange={(_, v) => setTab(v)}>
							<Tab
								icon={<TableRowsIcon sx={{ fontSize: 18 }} />}
								iconPosition="start"
								label="Listado"
								sx={{ textTransform: 'none', minHeight: 44 }}
							/>
							<Tab
								icon={<AccountTreeIcon sx={{ fontSize: 18 }} />}
								iconPosition="start"
								label="Por canal"
								sx={{ textTransform: 'none', minHeight: 44 }}
							/>
						</Tabs>
					</Box>

					{tab === 0 && <ClientPaymentsList />}
					{tab === 1 && <ReceiptsByChannelPanel />}
				</Grid>
			</Grid>
		</Layout>
	);
};
